(function () {
    'use strict';

    angular.module('soopkitchenApp').controller('PlanningEventDialogController', PlanningEventDialogController);

    PlanningEventDialogController.$inject = ['$scope', '$uibModalInstance', 'entity', 'AlertService', 'PlanningEventsService',
        'parameters', '$rootScope', 'Principal', 'SoopkitchenUtils', '$cookies', '$timeout', '$uibModal'];

    function PlanningEventDialogController($scope, $uibModalInstance, entity, AlertService, PlanningEventsService, parameters,
                                           $rootScope, Principal, SoopkitchenUtils, $cookies, $timeout, $uibModal) {
        var vm = this;
        var EVENT_DEFAULTS = {
            'SLEW': {
                'comment': { value: 'soc-added', extra: function() { vm.canDeleteEvent = true; } },
                'duration': { value: 300, displayValue: '5m', isDuration: true }
            },
            'HSD_': {
                'duration': { value: 900, displayValue: '15m', isDuration: true }
            },
            'POINT_CENTRE': {
                'boresight': { value: 'SC', isEnum: true },
                'metis_compatible': { value: 'YES', isEnum: true }
            }
        };

        function getEventDefaults(eventName) {
            if (EVENT_DEFAULTS[eventName]) {
                return EVENT_DEFAULTS[eventName];
            }
            for (var key in EVENT_DEFAULTS) {
                if (EVENT_DEFAULTS.hasOwnProperty(key) && key.charAt(key.length - 1) === '_' && eventName.indexOf(key) === 0) {
                    return EVENT_DEFAULTS[key];
                }
            }
            return null;
        }

        vm.containsDuration = false;
        vm.isEditable = false;
        vm.selectedNumber = {};
        vm.repeat = false;

        vm.preserveRatio = getPreserveRatio();
        vm.isDurationDisabled = isDurationDisabled;
        vm.isStartDateDisabled = isStartDateDisabled;
        vm.isEndDateDisabled = isEndDateDisabled;
        vm.onStartDateUpdate = onStartDateUpdate;
        vm.onEndDateUpdate = onEndDateUpdate;
        vm.updateStartDate = updateStartDate;
        vm.updateEndDate = updateEndDate;
        vm.onPreserveRatioClick = onPreserveRatioClick;
        vm.blinkingTimeout = 2000;

        vm.lettersSeparation = 0;
        vm.numberOccurences = 2;
        var events = [];
        vm.dialogTitle = parameters.action;
        Principal.hasAnyAuthority(['ROLE_PLAN_COORDINATOR', 'ROLE_POWER_USER']).then(function (result) {
            if (result) {
                if (parameters.locked != null) {
                    vm.isEditable = parameters.locked === false;
                }
                if ((parameters.occurrence != null) && (vm.isEditable === false)) {
                    vm.dialogTitle = "Visualizing";
                }
            }
        });
        vm.updateDuration = updateDuration;
        vm.takeValuesToUpdate = takeValuesToUpdate;
        vm.parseFloat = function (number) {
            return parseFloat(number);
        };
        vm.nameEventMap = {};
        vm.nameAllEventsMap = {};

        vm.attributeClassMap = {};
        vm.plan = entity;
        vm.clear = clear;
        vm.clearParameters = clearParameters;
        vm.selectedAtt = {};
        vm.selectedEnum = {};
        vm.savedItems = [];
        vm.disableCombobox = false;
        vm.showWarningForSOCEvents = false;
        vm.showWarningForSOCEventSets = false;
        var eventsSet = new Set();
        var allEventsSet = new Set();
        vm.repeatWrong = repeatWrong;
        vm.deleteDisabled = deleteDisabled;
        vm.deleteEvent = deleteEvent;
        vm.eventSetMap = {};

        vm.socEvents = [];

        function updateEventsCombo() {
            for (var index = 0; index < entity.schema.eventDefinitions.length; index++) {
                var eventName = entity.schema.eventDefinitions[index].name;
                if (entity.schema.eventDefinitions[index].canCreate) {
                    eventsSet.add(eventName);
                    vm.nameEventMap[eventName] = entity.schema.eventDefinitions[index];
                }
                allEventsSet.add(eventName);
                vm.nameAllEventsMap[eventName] = entity.schema.eventDefinitions[index];
            }
            vm.canDeleteEvent = true;
            vm.disableSave = false;
            if (parameters.occurrence != null) {

                vm.occurrence = parameters.occurrence;
                vm.startDate = parameters.startDate;
                vm.endDate = parameters.endDate;
                vm.canDeleteEvent = false;

                for (var index = 0; index < entity.schema.eventDefinitions.length; index++) {
                    var eventName = entity.schema.eventDefinitions[index].name;
                    if (entity.schema.eventDefinitions[index].canDelete && vm.occurrence.originalName === eventName) {
                        vm.canDeleteEvent = true;
                    }
                }
                if (vm.socEvents.includes(vm.occurrence.originalName)) {
                    vm.canDeleteEvent = true;
                    vm.showWarningForSOCEvents = true;
                    vm.disableSave = true;
                }

                vm.takeValuesToUpdate();
            } else {
                events = Array.from(eventsSet);
                events.sort();
                vm.events = events;
                // same date to start
                vm.startDate = SoopkitchenUtils.formattedDate(parameters.start);
                vm.endDate = SoopkitchenUtils.formattedDate(parameters.start);
            }
        }

        vm.socEventsSetsFunction = function successCallback(data) {
            // console.warn(data);
            if (data) {
                data = angular.fromJson(data);
                Object.keys(data).forEach(function(key) {
                    // Filter out the special properties added by AngularJS ($promise, $resolved)
                    if (key.charAt(0) !== '$') {
                        var eventSetName = key;          // This will be "RSW_EXT_MULTI"
                        var eventList = data[key];       // This will be the Array(5)
                        createSOCEvent(eventSetName, true);
                        console.log("Processing Event Set:", eventSetName);
                        vm.eventSetMap [eventSetName] = eventList;
                        // Now you can loop through the inner array
                        if (Array.isArray(eventList)) {
                            eventList.forEach(function(eventName, index) {
                                console.log("  - Event " + index + ":", eventName);

                            });
                        }
                    }
                });

            }
            updateEventsCombo();
        }

        function createSOCEvent(eventName, duration) {
            var attributes = [];
            attributes.push({name: 'comment', attributeClassName: 'string', required: false});
            if (duration) {
                attributes.push({name: 'duration', attributeClassName: 'durationType', required: false});
            }
            event = {
                name: eventName,
                canCreate: true,
                canModify: true,
                canDelete: true,
                attributes: attributes

            }

            allEventsSet.add(event.name);
            eventsSet.add(event.name);
            vm.nameEventMap[event.name] = event;
            vm.nameAllEventsMap[event.name] = event
            return event;
        }

        vm.socEventsSuccessFunction = function successCallback(data) {
            // console.warn(data);
            if (data) {
                data = angular.fromJson(data);
                data.forEach(function (eventName, index) {
                    event = createSOCEvent (eventName);
                    vm.socEvents.push(event.name);
                });

            }
            PlanningEventsService.getSOCEventSets(
                {}, vm.socEventsSetsFunction
                ,
                function errorCallback(response) {
                });


        }

        PlanningEventsService.getSOCEvents(
                {}, vm.socEventsSuccessFunction
                ,
                function errorCallback(response) {
                });


        vm.updateCalendar = updateCalendar;

        function repeatWrong() {
            if (vm.repeat === false) {
                return false;
            } else {
                return vm.frequency < vm.duration;
            }
        }

        vm.updateAtributeEnum = function (attributeName) {
            if (! vm.selectedEnum[attributeName]) {
                delete vm.selectedAtt[attributeName];
            } else {
                vm.selectedAtt[attributeName] = vm.selectedEnum[attributeName];
            }
        };
        vm.updateAtributeNumber = function (attributeName) {
            if (vm.selectedNumber[attributeName] != null) {
                vm.selectedAtt[attributeName] = vm.selectedNumber[attributeName].toString();
            }
        };
        vm.update = function () {
            vm.duration = null;
            vm.durationLetters = null;
            vm.selectedAtt = {};
            vm.selectedEnum = {};
            vm.selectedEvent = vm.nameAllEventsMap[vm.selectedEventName];
            // vm.selectedEvent = vm.nameEventMap[vm.selectedEventName];

            console.log(vm.selectedEvent)
            vm.isEditable = vm.selectedEvent.canModify;
            vm.showWarningForSOCEvents = false;


            vm.showWarningForSOCEventSets = false;
            var containsDuration = false;
            var defaults = getEventDefaults(vm.selectedEventName);

            for (var index = 0; index < vm.selectedEvent.attributes.length; index++) {
                var attributeClassName = vm.selectedEvent.attributes[index].attributeClassName;
                var eventName = vm.selectedEvent.name;
                eventsSet.add(eventName);
                var attributeName = vm.selectedEvent.attributes[index].name;
                var attributeClass = entity.schema.attributeClasses[attributeClassName];
                vm.attributeClassMap[attributeClassName] = attributeClass;

                if (attributeClassName === 'durationType') {
                    containsDuration = true;
                }
                if (vm.socEvents.includes(vm.selectedEventName)) {
                    vm.selectedAtt['comment'] = null;
                    vm.canDeleteEvent = true;
                }

                if (defaults && defaults[attributeName]) {
                    var attrDefault = defaults[attributeName];
                    if (attrDefault.isDuration) {
                        vm.selectedAtt[attributeName] = attrDefault.value;
                        vm.duration = attrDefault.value;
                        vm.durationLetters = attrDefault.displayValue;
                        vm.updateCalendar();
                    } else {
                        vm.selectedAtt[attributeName] = attrDefault.value;
                        if (attrDefault.isEnum) {
                            vm.selectedEnum[attributeName] = attrDefault.value;
                        }
                        if (attrDefault.extra) {
                            attrDefault.extra();
                        }
                    }
                }
            }
            vm.containsDuration = containsDuration;
            if (!vm.containsDuration) {
                vm.durationLetters = null;
            }

            if (vm.eventSetMap[vm.selectedEventName] != null) {
                vm.isEditable = true;
                vm.showWarningForSOCEventSets = true;
            }
        };

        vm.invalidParameters = function () {
            if (vm.selectedEvent == null)
                return true;
            for (var index = 0; index < vm.selectedEvent.attributes.length; index++) {
                var attribute = vm.selectedEvent.attributes[index];
                if (attribute.required) {
                    if (vm.selectedEvent.canModify) {
                        // sync ENUM and vm.selectedAtt
                        vm.updateAtributeEnum(attribute.name);
                        vm.updateAtributeNumber(attribute.name);
                    }
                    if (attribute.name !== 'time' && attribute.name !== 'duration' && vm.selectedAtt[attribute.name] == null) {
                        return true;
                    }
                }
            }
            return vm.containsDuration ? vm.duration == null : false;
        };

        vm.parametersWrong = function () {

            if (vm.invalidParameters())
                return true;
            if (vm.invalidateStartDate)
                return true;
            if (vm.invalidateEndDate)
                return true;
            if (vm.durationLettersInvalid())
                return true;
            if (vm.invalidateDateRange())
                return true;
            if (vm.outOfRangeDate())
                return true;
            return vm.repeatWrong();

        };

        vm.invalidateDateRange = function () {
            var endDateMilliseconds = Date.parse(vm.endDate).valueOf();
            var startDateMilliseconds = Date.parse(vm.startDate).valueOf();
            return startDateMilliseconds > endDateMilliseconds;
        };
        vm.outOfRangeDate = function () {
            return vm.startOutOfRangeDate() || vm.endOutOfRangeDate();
        };
        vm.endOutOfRangeDate = function () {
            var validEndDate = Date.parse(vm.plan.validityEndTime);
            var endDateMilliseconds = Date.parse(vm.endDate).valueOf();

            return endDateMilliseconds > validEndDate.valueOf();
        };
        vm.startOutOfRangeDate = function () {
            var validStartDate = Date.parse(vm.plan.validityStartTime);
            var startDateMilliseconds = Date.parse(vm.startDate).valueOf();

            return startDateMilliseconds < validStartDate.valueOf();
        };

        vm.repeatOutOfRangeDate = function () {
            if (vm.repeat === false) {
                return false;
            } else {
                var validEndDate = Date.parse(vm.plan.validityEndTime);
                var endDateMilliseconds = Date.parse(vm.lastEndTime).valueOf();
                return endDateMilliseconds > validEndDate.valueOf();
            }
        };

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        vm.reset = function () {
        };

        vm.save = function () {
            var count = 0;
            if (vm.selectedAtt['count'] != null) {
                count = vm.selectedAtt['count'];
            }
            delete vm.selectedAtt['count']
            delete vm.selectedAtt['duration']
            var event = {
                "count": count,
                "endDate": vm.endDate,
                "name": vm.selectedEventName,
                "parameters": vm.selectedAtt,
                "startDate": vm.startDate
            };
            if ((parameters.occurrence != null) && parameters.cut) {
                updateEventInPlan(event);
            } else if (vm.eventSetMap[vm.selectedEventName] != null) {
                var eventList = [];
                if (Array.isArray(vm.eventSetMap[vm.selectedEventName])) {
                    vm.eventSetMap[vm.selectedEventName].forEach(function(eventName, index) {
                        var event = {

                            "count": count,
                            "endDate": vm.endDate,
                            "name": eventName,
                            "parameters": vm.selectedAtt,
                            "startDate": vm.startDate
                        };
                        eventList.push(event);
                    });
                }
                addEventListInPlan(eventList, event);
            } else {
                saveEventInPlan(event);
            }
        };

        function addEventListInPlan(eventList, event) {
            PlanningEventsService.addEvent(
                {
                    planLabel: entity.label,
                },
                eventList,
                function successCallback(data) {
                    AlertService.success("Added Event " + vm.selectedEventName + " : " + vm.startDate + " --> " + vm.endDate + " to Plan successfully");
                    if (vm.socEvents.includes(vm.selectedEventName)) {
                        PlanningEventsService.expandSOCEvents({
                            planLabel: entity.label
                        }, event, function successCallback(data) {
                            AlertService.success("Expanded SOC Event " + event.name + " : " + event.startDate + " --> " + event.endDate + " to Plan successfully");
                            updateTimeLine(true, data);
                            $uibModalInstance.dismiss('cancel')
                        }, function errorCallback(response) {
                            SoopkitchenUtils.prettyError(response);
                        })
                    } else {
                        updateTimeLine(true, data);

                        $uibModalInstance.dismiss('cancel')
                    }
                },
                function errorCallback(response) {
                    SoopkitchenUtils.prettyError(response);
                });
        }

        function createEventAndAddToList(event, occurrence, eventList) {
            var newEvent = JSON.parse(JSON.stringify(event));
            var newStartDate = new Date(Date.parse(vm.startDate).valueOf() + vm.frequency * (occurrence) * 1000);
            var newEndDate = new Date(Date.parse(vm.endDate).valueOf() + vm.frequency * (occurrence) * 1000);
            newEvent.startDate = newStartDate;
            newEvent.endDate = newEndDate;
            eventList.push(newEvent);
        }

        function saveEventInPlan(event) {

            var eventList = [];
            if (vm.repeat === false) {
                eventList.push(event);
            } else {
                for (var occurrence = 0; occurrence < vm.numberOccurences; occurrence++) {
                    createEventAndAddToList(event, occurrence, eventList);
                }
            }

            addEventListInPlan(eventList, event);
        }

        function updateEventInPlan(event) {
            updateEvent(parameters.occurrence, event);
            if (vm.repeat === true) {
                var eventList = [];

                for (var occurrence = 1; occurrence < vm.numberOccurences; occurrence++) {
                    createEventAndAddToList(event, occurrence, eventList);
                }
                PlanningEventsService.addEvent(
                    {
                        planLabel: entity.label
                    },
                    eventList,
                    function successCallback(data) {
                        AlertService.success("Added Event " + vm.selectedEventName + " : " + vm.startDate + " --> " + vm.endDate + " to Plan successfully");
                        updateTimeLine(true, data);
                        $uibModalInstance.dismiss('cancel');

                    },
                    function errorCallback() {
                        SoopkitchenUtils.prettyError(response);
                    });
            }
        }

        function updateEvent(existingEvent, updatedEvent) {
            var listEvents = [];
            existingEvent.name = existingEvent.originalName;
            listEvents.push(
                {
                    "updatedHappening": updatedEvent,
                    "existingHappening": existingEvent
                }
            );

            PlanningEventsService.updateEvent(
                {
                    planLabel: entity.label,
                },
                { "updateList" : listEvents },
                function successCallback(data) {
                    AlertService.success("Updated Event " + updatedEvent.name + " : " + updatedEvent.startDate + " --> " + updatedEvent.endDate + " to Plan successfully");
                    updateTimeLine(true, data);
                    $uibModalInstance.dismiss('cancel');

                },
                function errorCallback(response) {
                    SoopkitchenUtils.prettyError(response);
                });
        }

        function updateTimeLine(highlightOccurrance, data) {
            if (highlightOccurrance) {
                var count = 0;
                if (vm.selectedAtt['count'] != null) {
                    count = vm.selectedAtt['count'];
                }
                var name = vm.selectedEventName;
                if (vm.eventSetMap[vm.selectedEventName] != null) {
                    name = vm.eventSetMap[vm.selectedEventName][0];
                }
                var event = {
                    "count": count,
                    "endDate": vm.endDate,
                    "name": name,
                    "parameters": vm.selectedAtt,
                    "startDate": vm.startDate
                };
                $rootScope.$broadcast('updateList', {
                    newOccurrance: event,
                    oldOccurrance: parameters.occurrence,
                    data: data
                });
            } else {
                SoopkitchenUtils.updatePlanFromDialog(data);
                $uibModalInstance.dismiss('cancel');

            }
        }

        vm.updateLetters = function () {
            vm.duration = SoopkitchenUtils.timeToSeconds(vm.durationLetters);
            var newDate = new Date(Date.parse(vm.startDate).valueOf() + vm.duration * 1000);
            vm.endDate = SoopkitchenUtils.formattedDate(newDate);
            blinkDuration(false, true);
        };

        vm.updateLettersFrequency = function () {
            vm.durationLettersFrequency = SoopkitchenUtils.secondsToTime(vm.frequency);
            var newDate = new Date(Date.parse(vm.endDate).valueOf() + vm.frequency * (vm.numberOccurences - 1) * 1000);
            vm.lastEndTime = SoopkitchenUtils.formattedDate(newDate);
        };
        vm.updateFrequency = function () {
            vm.frequency = SoopkitchenUtils.timeToSeconds(vm.durationLettersFrequency);
            var newDate = new Date(Date.parse(vm.endDate).valueOf() + vm.frequency * (vm.numberOccurences - 1) * 1000);
            vm.lastEndTime = SoopkitchenUtils.formattedDate(newDate);
        };

        function clearParameters() {
            vm.nameEventMap = {};
            vm.attributeClassMap = {};
            vm.duration = null;
            vm.durationLetters = null;
        }

        function updateCalendar() {
            vm.durationLetters = SoopkitchenUtils.secondsToTime(vm.duration);
            var newDate = new Date(Date.parse(vm.startDate).valueOf() + vm.duration * 1000);
            vm.endDate = SoopkitchenUtils.formattedDate(newDate);
            if (vm.repeat) {
                vm.lastEndTime = SoopkitchenUtils.formattedDate(newDate);
            }
            blinkDuration(true, false);
        }

        function blinkDuration(blinkDurationLetters, blinkDuration) {
            if (blinkDurationLetters) {
                vm.durationLettersStyle = getCssBlinkingStyle();
            }
            if (blinkDuration) {
                vm.durationStyle = getCssBlinkingStyle();
            }
            $timeout(function () {
                vm.durationLettersStyle = null;
                vm.durationStyle = null;
            }, vm.blinkingTimeout);
        }

        function updateDuration(blink) {
            if (SoopkitchenUtils.isValidDate(vm.startDate)) {
                vm.invalidateStartDate = false;
                if (SoopkitchenUtils.isValidDate(vm.endDate)) {
                    vm.invalidateEndDate = false;
                } else {
                    vm.invalidateEndDate = true;
                    return;
                }
                vm.duration = (Date.parse(vm.endDate) - Date.parse(vm.startDate)) / 1000;
                vm.durationLetters = SoopkitchenUtils.secondsToTime(vm.duration);
                if (blink) {
                    blinkDuration(true, true);
                }
            } else {
                vm.invalidateStartDate = true;
            }
        }

        function takeValuesToUpdate() {
            var name = parameters.occurrence.originalName;
            if (belongsToSet(eventsSet, name)) {
                vm.selectedEvent = vm.nameAllEventsMap[name];
                events = Array.from(eventsSet);
                events.sort();
                vm.events = events;
            } else if (belongsToSet(allEventsSet, name)) {
                events = Array.from(allEventsSet);
                events.sort();
                vm.events = events;
                vm.selectedEvent = vm.nameAllEventsMap[name];
                vm.disableCombobox = true;
            } else {
                clear();
                SoopkitchenUtils.invokeSweetAlert("Ooops", "It is not possible to edit that event, sorry!!", "error");
                $uibModalInstance.dismiss('cancel');
            }
            vm.disableCombobox =  (vm.selectedEvent.canModify && vm.selectedEvent.canCreate && vm.selectedEvent.canDelete) === false;
            vm.disableInputs = vm.selectedEvent.canModify === false;

            if (vm.occurrence.originalName === "SLEW") {
                if (!(vm.occurrence.parameters.comment !=null && vm.occurrence.parameters.comment.indexOf('soc-added') !== -1)) {
                    vm.disableCombobox = true;
                    vm.disableInputs = true;
                    vm.canDeleteEvent =false;
                }
            }

            var containsDuration = false;

            vm.selectedEventName = vm.selectedEvent.name;
            for (var index = 0; index < vm.selectedEvent.attributes.length; index++) {

                var attribute = vm.selectedEvent.attributes[index];

                vm.selectedAtt[attribute.name] = parameters.occurrence.parameters[attribute.name];
                var attributeClassName = attribute.attributeClassName;
                var attributeClass = entity.schema.attributeClasses[attributeClassName];
                vm.attributeClassMap[attributeClassName] = attributeClass;

                if (vm.attributeClassMap[attribute.attributeClassName].type === 'ENUM') {
                    if (parameters.occurrence.parameters[attribute.name]) {
                        vm.selectedEnum[attribute.name] = parameters.occurrence.parameters[attribute.name];
                    }
                } else if (vm.attributeClassMap[attribute.attributeClassName].type === 'FLOAT') {
                    vm.selectedAtt[attribute.name] = parseFloat(parameters.occurrence.parameters[attribute.name]);
                    vm.selectedNumber[attribute.name] = parseFloat(parameters.occurrence.parameters[attribute.name]);
                } else if (vm.attributeClassMap[attribute.attributeClassName].type === 'INTEGER') {
                    vm.selectedAtt[attribute.name] = parseInt(parameters.occurrence.parameters[attribute.name]);
                    vm.selectedNumber[attribute.name] = parseInt(parameters.occurrence.parameters[attribute.name]);
                    // for count
                    if (attribute.name === 'count') {
                        if (parseInt(parameters.occurrence.count) > 0) {
                            vm.selectedAtt['count'] = parseInt(parameters.occurrence.count);
                            vm.selectedNumber['count'] = parseInt(parameters.occurrence.count);
                        }
                    }
                }

                if (attributeClassName === 'durationType') {
                    containsDuration = true;
                }
            }
            vm.containsDuration = containsDuration;
            vm.updateDuration(false);
        }

        vm.durationLettersInvalid = function () {
            if (vm.durationLetters == null || vm.containsDuration == false);
                return false;
            return (SoopkitchenUtils.timeToSeconds(vm.durationLetters) === 0 || isNaN(SoopkitchenUtils
                .timeToSeconds(vm.durationLetters)));
        };

        function belongsToSet(thisSet, name) {
            if (thisSet.has(name)) {
                return true;
            } else {
                if (name.indexOf(" ") > 0) {
                    var shortName = name.substring(0, name.indexOf(" "));
                    return thisSet.has(shortName);
                }
                return false;
            }

        }

        function deleteDisabled() {
            return (vm.canDeleteEvent === false || vm.isEditable === false);
        }

        function deleteEvent() {
            var event = null;
            for (var index = 0; index < vm.plan.schema.eventDefinitions.length; index++) {
                var eventName = vm.plan.schema.eventDefinitions[index].name;
                if (vm.occurrence.originalName === eventName) {
                    event = vm.plan.schema.eventDefinitions[index];
                    break;
                }
            }
            if (event != null && event.canDelete === false && vm.socEvents.includes(vm.occurrence.originalName) === false) {
                SoopkitchenUtils.invokeSweetAlert("Ooops", "It is not possible to delete that event", "error");
                return;

            } else if (event == null && vm.socEvents.includes(vm.occurrence.originalName) === false) {
                SoopkitchenUtils.invokeSweetAlert("Ooops", "It is not possible to delete that event (not in the white list)",
                    "error");
                return;
            }
            var message = 'Do you really want to remove item ' + vm.occurrence.name;
            if (vm.socEvents.includes(vm.occurrence.originalName)) {
                message += " (and its expanded events!)";
            }

            message +=' with start date ' + vm.occurrence.startDate + ' ? '
            SoopkitchenUtils.prettyConfirm('Remove item', message, function (ok) {
                if (ok) {
                    var occurrences = [];
                    vm.occurrence.name = vm.occurrence.originalName;
                    occurrences.push(vm.occurrence);
                    PlanningEventsService.deleteEvent(
                        {
                            planLabel: vm.plan.label
                        },
                        occurrences,
                        function successCallback(data) {
                            updateTimeLine(false, data);
                            $uibModalInstance.dismiss('cancel');
                            AlertService.success("Deleted Event successfully");
                        },
                        function (response) {
                            SoopkitchenUtils.prettyError(response);
                        });
                }
            });
        }

        function getPreserveRatio() {
            var defaultValue = "dates";
            if ($cookies.get("preserveRatio") != null) {
                defaultValue = $cookies.get("preserveRatio");
            }
            if (vm.selectedEvent == null) {
                // If event is to be created, return default or cookie value (if exists)
                return defaultValue;
            } else if (isDurationDisabled() || vm.containsDuration === false) {
                // If duration is disabled, return "duration"
                return "duration";
            } else {
                // Any other case, return default or cookie value (if exists)
                return defaultValue;
            }
        }
        function onPreserveRatioClick() {
            $cookies.put("preserveRatio", vm.preserveRatio);
        }

        function isDurationDisabled() {
            if (vm.selectedEvent == null) {
                return vm.disableInputs || vm.isEditable === false;
            } else {
                return vm.disableInputs || vm.isEditable === false || vm.selectedEvent.canModify === false;
            }
        }

        function isStartDateDisabled() {
            return isDurationDisabled();
        }

        function isEndDateDisabled() {
            return vm.disableInputs || vm.containsDuration === false || vm.isEditable === false;
        }

        function onStartDateUpdate() {

            if (vm.containsDuration && vm.preserveRatio === "dates") {
                vm.updateDuration(true);
            } else {
                vm.updateEndDate();
            }
        }

        function onEndDateUpdate() {
            if (vm.preserveRatio === "dates") {
                vm.updateDuration(true);
            } else {
                vm.updateStartDate();
            }
        }

        function updateStartDate() {
            if (SoopkitchenUtils.isValidDate(vm.endDate)) {
                vm.invalidateEndDate = false;
            } else {
                vm.invalidateEndDate = true;
                return;
            }
            var newDate = new Date(Date.parse(vm.endDate).valueOf() - vm.duration * 1000);
            vm.startDate = SoopkitchenUtils.formattedDate(newDate);
            vm.startDateStyle = getCssBlinkingStyle();
            $timeout(function () {
                vm.startDateStyle = null;
            }, vm.blinkingTimeout);
        }

        function updateEndDate() {
            if (SoopkitchenUtils.isValidDate(vm.startDate)) {
                vm.invalidateStartDate = false;
            } else {
                vm.invalidateStartDate = true;
                return;
            }

            if (vm.containsDuration === false){
                vm.duration = 0;
            }

            var newDate = new Date(Date.parse(vm.startDate).valueOf() + vm.duration * 1000);
            vm.endDate = SoopkitchenUtils.formattedDate(newDate);
            if (vm.repeat) {
                var newFinalDate = new Date(Date.parse(vm.endDate).valueOf() + vm.frequency * (vm.numberOccurences - 1) * 1000);
                vm.lastEndTime = SoopkitchenUtils.formattedDate(newFinalDate);
            }
            vm.endDateStyle = getCssBlinkingStyle();
            $timeout(function () {
                vm.endDateStyle = null;
            }, vm.blinkingTimeout);
        }

        function getCssBlinkingStyle() {
            return {
                'animation': 'blinker 1s linear infinite',
                'color': 'blue'
            };
        }

    }
})();
